import { render, staticRenderFns } from "./Science-schedule.vue?vue&type=template&id=41b9b2ac&scoped=true&"
import script from "./Science-schedule.vue?vue&type=script&lang=js&"
export * from "./Science-schedule.vue?vue&type=script&lang=js&"
import style0 from "./Science-schedule.vue?vue&type=style&index=0&id=41b9b2ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b9b2ac",
  null
  
)

export default component.exports